import { render, staticRenderFns } from "./JR2Imbangan.vue?vue&type=template&id=4c685a8e"
import script from "./JR2Imbangan.vue?vue&type=script&lang=js"
export * from "./JR2Imbangan.vue?vue&type=script&lang=js"
import style0 from "./JR2Imbangan.vue?vue&type=style&index=0&id=4c685a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports